import {
  Color4,
  ParticleSystem,
  Scene,
  Texture,
  Vector3
} from "../../app/babylon";
import { assets } from "../assets";

export class SnowSpray {
  private system: ParticleSystem;
  private emitterPos = new Vector3();

  constructor(scene: Scene) {
    this.system = new ParticleSystem("spray", 700, scene);
    this.system.particleTexture = new Texture(assets.powderSnow, scene);
    this.system.emitter = this.emitterPos;
    this.system.minEmitBox = new Vector3(-0.05, 0, -0.05);
    this.system.maxEmitBox = new Vector3(0.05, 0.06, 0.05);

    this.system.color1 = new Color4(1, 1, 1, 0.95);
    this.system.color2 = new Color4(0.92, 0.96, 1, 0.85);
    this.system.colorDead = new Color4(1, 1, 1, 0);

    this.system.minSize = 0.12;
    this.system.maxSize = 0.4;
    this.system.minLifeTime = 0.3;
    this.system.maxLifeTime = 0.7;

    this.system.emitRate = 0;
    this.system.blendMode = ParticleSystem.BLENDMODE_STANDARD;

    this.system.gravity = new Vector3(0, -3, 0);
    this.system.direction1 = new Vector3(-0.4, 0.5, -0.5);
    this.system.direction2 = new Vector3(0.4, 1.2, 0.5);

    this.system.minAngularSpeed = -2;
    this.system.maxAngularSpeed = 2;
    this.system.minEmitPower = 1.2;
    this.system.maxEmitPower = 3.2;
    this.system.updateSpeed = 0.018;

    this.system.start();
  }

  update(
    intensity: number,
    riderPos: Vector3,
    headingRight: Vector3,
    backDir: Vector3,
    edgeOffset: Vector3
  ): void {
    this.emitterPos.set(
      riderPos.x + edgeOffset.x,
      riderPos.y + edgeOffset.y,
      riderPos.z + edgeOffset.z
    );

    if (intensity > 0.05) {
      const i = Math.min(1, intensity);
      this.system.emitRate = 60 + i * 360;
      this.system.minSize = 0.12 + i * 0.18;
      this.system.maxSize = 0.32 + i * 0.5;
      this.system.minEmitPower = 1.5 + i * 2.5;
      this.system.maxEmitPower = 3.0 + i * 4.0;

      const sideX = headingRight.x;
      const sideZ = headingRight.z;
      const backX = backDir.x;
      const backZ = backDir.z;
      this.system.direction1 = new Vector3(
        sideX * 0.4 + backX * 1.5,
        0.4,
        sideZ * 0.4 + backZ * 1.5
      );
      this.system.direction2 = new Vector3(
        sideX * 1.2 + backX * 3.0,
        1.6,
        sideZ * 1.2 + backZ * 3.0
      );
    } else {
      this.system.emitRate = 0;
    }
  }

  dispose(): void {
    this.system.dispose();
  }
}
